import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asset-is-background-information-popover',
  templateUrl: './asset-is-background-information-popover.component.html',
  styleUrls: ['./asset-is-background-information-popover.component.scss'],
})
export class AssetIsBackgroundInformationPopoverComponent implements OnInit {

  public isEditing: boolean;
  public assetType: string;

  constructor() { }

  ngOnInit() {}

}
